module.exports = __webpack_public_path__ + "img/美妆特效--大图.a2abadde.png";